import React from 'react';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import Slider from './slider';
import { reactSelectStyle } from '../../componentStyles';
import setActiveBrand from '../../redux/actions/carBrand';
import setActiveModel from '../../redux/actions/carModel';
import setActiveBodyType from '../../redux/actions/bodyType';
import setProductionYearFrom from '../../redux/actions/productionYearFrom';
import setProductionYearTo from '../../redux/actions/productionYearTo';
import setTransmissionType from '../../redux/actions/transmissionType';
import setEngineType from '../../redux/actions/engineType';
import setSearchCars from '../../redux/actions/searchCars';
import sortCarsArray from '../../redux/actions/catalogSort';
import setActivePage from '../../redux/actions/pagination';
import setPrices from '../../redux/actions/price';
import setShowCars from '../../redux/actions/carCard';
import { None, MIN_PRICE, MAX_PRICE, DELAY } from '../../constants';
import { scrollPageToTop } from '../../utilites';

export default () => {
  const {
    carBrands,
    bodyTypes,
    transmissionTypes,
    engineTypes,
    dictionary,
    options,
  } = startup;

  const carBrand = useSelector((state) => state.search.Brand);
  const carModel = useSelector((state) => state.search.Model);
  const bodyType = useSelector((state) => state.search.BodyType);
  const productionYearFrom = useSelector(
    (state) => state.search.ProductionYearFrom
  );
  const productionYearTo = useSelector(
    (state) => state.search.ProductionYearTo
  );
  const transmissionType = useSelector(
    (state) => state.search.TransmissionType
  );
  const engineType = useSelector((state) => state.search.EngineType);
  const orderedBy = useSelector((state) => state.catalog.orderedBy);

  const dispatch = useDispatch();

  if (options && options !== 'default') {
    const state = JSON.parse(options);
    const data = new Map();
    dispatch(setActiveBrand(state.carBrand));
    dispatch(setActiveModel(state.carModel));
    dispatch(setPrices([MIN_PRICE, state.price]));
    data.set('MinPrice', MIN_PRICE);
    data.set('MaxPrice', state.price);
    data.set('Brand', state.carBrand);
    data.set('Model', state.carModel);
    dispatch(setSearchCars(startup.cars, data));
    startup.options = '';
  }

  const getFormResult = () => {
    const searchCarForm = document.querySelector('#searchCarForm');
    const formResult = new FormData(searchCarForm);
    const data = new Map(formResult);
    data.set(
      'MinPrice',
      parseInt(data.get('MinPrice').replace(/[\s.,€,$]/g, ''), 10)
    );
    data.set(
      'MaxPrice',
      parseInt(data.get('MaxPrice').replace(/[\s.,€,$]/g, ''), 10)
    );
    if (data.get('MinYear') !== None)
      data.set('MinYear', parseInt(data.get('MinYear'), 10));
    if (data.get('MaxYear') !== None)
      data.set('MaxYear', parseInt(data.get('MaxYear'), 10));
    // if (data.get('Brand') === None) {
    //   alert('Choose at least a brand, please!');
    //   return;
    // } // check form
    const carsState = dispatch(setSearchCars(startup.cars, data)).payload;
    dispatch(sortCarsArray(carsState, orderedBy));
  };

  const defaultOption = { value: None, label: dictionary.None };
  const brandOptions = Object.keys(carBrands).map((el) => ({
    value: el,
    label: el,
  }));

  const modelOptions = carBrand
    ? [
        defaultOption,
        ...carBrands[carBrand].map((el, index) => {
          if (index === carBrands[carBrand].length - 1) {
            return { value: el, label: dictionary[el] };
          }
          return { value: el, label: el };
        }),
      ]
    : [defaultOption];

  const bodyTypesOptions = bodyTypes
    .map((el) => ({ value: el, label: dictionary[el] }))
    .filter((el, idx) => idx !== 9); // 9 - not used value; now sedan = 10

  const productionYearFromOptions = new Array(
    startup.currentYear - startup.startYear + 1
  )
    .fill(0)
    .map((el, id) => ({
      value: startup.startYear + id,
      label: startup.startYear + id,
    }));

  const startProductionYearTo = productionYearFrom || startup.startYear;

  const productionYearToOptions = new Array(
    startup.currentYear - startProductionYearTo + 1
  )
    .fill(0)
    .map((el, id) => ({
      value: startProductionYearTo + id,
      label: startProductionYearTo + id,
    }));

  const transmissionTypesOptions = transmissionTypes.map((el) => ({
    value: el,
    label: dictionary[el],
  }));

  const engineTypesOptions = engineTypes.map((el) => ({
    value: el,
    label: dictionary[el],
  }));

  return (
    <div className="widget section-sidebar bg-light">
      <h3 className="widget-title bg-dark">
        <i className="ic flaticon-car-4" />
        {dictionary.SearchACar}
      </h3>
      <div className="widget-content">
        <div className="widget-inner">
          <form className="b-filter bg-light" id="searchCarForm">
            <div className="b-filter__main">
              <div className="b-filter__row">
                <input
                  value={carBrand || None}
                  form="searchCarForm"
                  name="Brand"
                  hidden
                  readOnly
                />
                <Select
                  // Car Brand
                  styles={reactSelectStyle}
                  className="catalogFilter brand"
                  placeholder={dictionary.Brand}
                  options={brandOptions}
                  value={carBrand ? { value: carBrand, label: carBrand } : null}
                  onChange={(option) => {
                    dispatch(setActiveBrand(option.value));
                    dispatch(setActiveModel(defaultOption.value));
                  }}
                />
              </div>
              <div className="b-filter__row" id="select_model">
                <input
                  value={carModel || None}
                  form="searchCarForm"
                  name="Model"
                  hidden
                  readOnly
                />
                <Select
                  // Car Model
                  styles={reactSelectStyle}
                  className="catalogFilter model"
                  placeholder={dictionary.Model}
                  options={modelOptions}
                  value={
                    carModel
                      ? modelOptions.find((el) => el.value === carModel)
                      : null
                  }
                  onChange={(option) => dispatch(setActiveModel(option.value))}
                />
              </div>
              <div className="b-filter__row">
                <input
                  value={bodyType || None}
                  form="searchCarForm"
                  name="BodyId"
                  hidden
                  readOnly
                />
                <Select
                  // BodyType
                  styles={reactSelectStyle}
                  className="catalogFilter bodyType"
                  placeholder={dictionary.BodyType}
                  options={bodyTypesOptions}
                  value={
                    bodyType
                      ? bodyTypes.find((el) => el.value === bodyType)
                      : null
                  }
                  onChange={(option) =>
                    dispatch(setActiveBodyType(option.value))
                  }
                />
              </div>
              <div className="b-filter__row row">
                <div className="b-filter__item col-md-6 col-lg-12 col-xl-6">
                  <input
                    value={productionYearFrom || None}
                    form="searchCarForm"
                    name="MinYear"
                    hidden
                    readOnly
                  />
                  <Select
                    // Production Year From
                    styles={reactSelectStyle}
                    className="catalogFilter productionYearFrom"
                    placeholder={dictionary.From}
                    options={productionYearFromOptions}
                    value={
                      productionYearFrom
                        ? {
                            value: productionYearFrom,
                            label: productionYearFrom,
                          }
                        : null
                    }
                    onChange={(option) => {
                      const yearFrom = dispatch(
                        setProductionYearFrom(option.value)
                      ).payload;
                      if (!productionYearTo || yearFrom > productionYearTo) {
                        dispatch(setProductionYearTo(option.value));
                      }
                    }}
                  />
                </div>
                <div className="b-filter__item col-md-6 col-lg-12 col-xl-6">
                  <input
                    value={productionYearTo || None}
                    form="searchCarForm"
                    name="MaxYear"
                    hidden
                    readOnly
                  />
                  <Select
                    // Production Year To
                    styles={reactSelectStyle}
                    className="catalogFilter productionYearTo"
                    placeholder={dictionary.To}
                    options={productionYearToOptions}
                    value={
                      productionYearTo
                        ? { value: productionYearTo, label: productionYearTo }
                        : null
                    }
                    onChange={(option) =>
                      dispatch(setProductionYearTo(option.value))
                    }
                  />
                </div>
              </div>
              <div className="b-filter__row">
                <input
                  value={transmissionType || None}
                  form="searchCarForm"
                  name="TransmissionId"
                  hidden
                  readOnly
                />
                <Select
                  // Transmission
                  styles={reactSelectStyle}
                  className="catalogFilter transmission"
                  placeholder={dictionary.Transmission}
                  options={transmissionTypesOptions}
                  value={
                    transmissionType
                      ? transmissionTypesOptions.find(
                          (el) => el.value === transmissionType
                        )
                      : null
                  }
                  onChange={(option) =>
                    dispatch(setTransmissionType(option.value))
                  }
                />
              </div>
              <div className="b-filter__row">
                <input
                  value={engineType || None}
                  form="searchCarForm"
                  name="EngineId"
                  hidden
                  readOnly
                />
                <Select
                  // Engine
                  styles={reactSelectStyle}
                  className="catalogFilter engine"
                  placeholder={dictionary.Engine}
                  options={engineTypesOptions}
                  value={
                    engineType
                      ? engineTypesOptions.find((el) => el.value === engineType)
                      : null
                  }
                  onChange={(option) => dispatch(setEngineType(option.value))}
                />
              </div>
            </div>
            <Slider />
            <button
              className="b-filter__reset btn btn-default w-100"
              type="button"
              onClick={() => {
                dispatch(setShowCars(false));
                setTimeout(() => {
                  dispatch(sortCarsArray(startup.cars, orderedBy));
                  dispatch(setActiveBrand(null));
                  dispatch(setActiveBodyType(null));
                  dispatch(setProductionYearFrom(null));
                  dispatch(setProductionYearTo(null));
                  dispatch(setTransmissionType(null));
                  dispatch(setEngineType(null));
                  dispatch(setPrices([MIN_PRICE, MAX_PRICE]));
                  dispatch(setShowCars(true));
                  scrollPageToTop();
                }, DELAY);
              }}
            >
              {dictionary.ResetFilters}
            </button>
            <button
              className="btn btn-primary w-100"
              type="button"
              onClick={() => {
                dispatch(setShowCars(false));
                setTimeout(() => {
                  dispatch(setActivePage(0));
                  getFormResult();
                  dispatch(setShowCars(true));
                  scrollPageToTop();
                }, DELAY);
              }}
            >
              {dictionary.ShowResult}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
